import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchApiDataIfNeeded } from '../../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'

import { formatCurrency } from '../../../utils/formatters'

import moment from 'moment'

import { PaginationWrapper } from 'shs-pagination'

const mapStateToProps = (state) => {
    const paginator = state.paginator.adminReceivedCommissions
    let receipts = state.adminReceipts
    if (paginator) {
        receipts = receipts
            .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
            .sort((a, b) => {
                if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                    return 1
                }
                return -1
            })
    }
    return { receipts, paginator }
}

const ListReceipts = ({ dispatch, receipts, paginator }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/receipts', 'LIST')))
    }, [dispatch])

    const renderReceiptRow = (receipt, index) => {
        return (
            <tr key={receipt.id}>
                <td className="index">{index}</td>
                <td className="main">
                    {formatCurrency(receipt.gross)}
                </td>
                <td className="main">
                    {formatCurrency(receipt.fees)}
                </td>
                <td className="main">
                    {formatCurrency(receipt.net)}
                </td>
                <td className="main">
                    {formatCurrency(receipt.balance)}
                </td>
                <td className="main">
                    <Link to={buildRoutePath(routes.adminVendorsView, { vendorId: receipt.vendorId })}>
                        {receipt._computed.vendorName}
                    </Link>
                </td>
                <td className="main">
                    {moment(receipt.receivedOn).format('ddd. MMMM DD, Y')}
                </td>
                <td className="main">
                    <Link to={buildRoutePath(routes.adminFinanceReceiptsView, { receiptId: receipt.id })}>
                        View
                    </Link>
                </td>
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/receipts', 'LIST'), paginationParams))
    }

    const renderReceipts = () => {
        if (!paginator) {
            return null
        }
        let allReceipts = []
        receipts.forEach((receipt, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allReceipts.push(renderReceiptRow(receipt, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: true } }}
                callbackFX={handlePaginationUpdate}
                countOptions={[5, 10, 20]}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Gross</th>
                            <th>Fees</th>
                            <th>Net</th>
                            <th>Balance</th>
                            <th>Vendor</th>
                            <th>Received On</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allReceipts}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    return (
        <div>
            <h1>Received Commissions</h1>
            <p>
                <Link to={routes.adminFinanceReceiptsCreate}>Create a new receipt</Link>
            </p>
            {renderReceipts()}
        </div>
    )
}

export default connect(mapStateToProps)(ListReceipts)
